export const APP_PAGES = [
  '/',
  '/dashboard',
  '/cli-connect',
  '/new-tab',
  '/design-system',
  '/canvas',
  // '/extension',
  '/components',
  '/init',
  '/search',
  '/switch',
  '/studio',
  '/schema',
  '/fetch',
  '/onboarding',
  '/settings',
  '/editor',
  '/files',
  '/layouts',
  '/atoms',
  '/marketplace',
  '/editor',
  '/export',
  '/pages',
  '/page',
  '/account',
  '/data',
  '/state',
  '/logout',
  '/color',
  '/theme',
  '/connect',
  '/install',
  '/integrations',
  '/typography',
  '/spacing',
  '/shape',
  '/governance',
  '/font',
  '/cases',
  '/timing',
  '/composite',
  '/icons',
  '/grid',
  '/media'
]

export const GUEST_PAGES = [
  '/signin',
  '/reset-password',
  '/access-signup',
  '/signup',
  '/privacy',
  '/terms',
  '/confirm',
  '/get-early-access'
]

export const GREEN_PAGES = [
  '/invest',
  '/careers',
  '/sandpack',
  '/compile',
  '/box-model',
  '/box-size',
  '/schedule-demo',
  '/invite',
  '/accept-invite',
  '/google-auth-callback',
  '/github-auth-callback',
  '/docs',
  '/pricing',
  '/pricing-lifetime',
  '/props',
  '/snippet',
  '/functions',
  '/function',
  '/watch',
  '/tutorial',
  '/tutorials',
  '/convert',
  '/playground',
  '/fiddles',
  '/developers',
  '/timeline',
  '/index',
  '/extension',
  '/api',
  '/cli',
  '/waitlist',
  // '/library',
  '/component',
  '/blocks',
  '/block',
  '/properties',
  '/convert',
  '/markdown',
  '/learning-center'
]

export function redirectBasedOnAuth(route) {
  const redirectInside = (innerRoute) => {
    const pathname = innerRoute
    const isInApp = this.call('checkIfStringIsInArray', pathname, APP_PAGES)
    const isGreen = this.call('checkIfStringIsInArray', pathname, GREEN_PAGES)
    const isInGuests = this.call(
      'checkIfStringIsInArray',
      pathname,
      GUEST_PAGES
    )
    if (
      (isInApp || isGreen || !isInGuests) &&
      innerRoute &&
      innerRoute !== '/'
    ) {
      return innerRoute
    }

    return '/dashboard' // fallback to dashboard
  }

  const redirectOutside = (innnerRoute) => {
    const isInGuests = this.call(
      'checkIfStringIsInArray',
      innnerRoute,
      GUEST_PAGES
    )
    const isGreen = this.call(
      'checkIfStringIsInArray',
      innnerRoute,
      GREEN_PAGES
    )
    if (isInGuests || isGreen) {
      return innnerRoute
    }

    const path = window.location.pathname
    // allow embed
    if (path.startsWith('/embed')) {
      return path
    }
    const [, user, projectKey] = path.split('/')
    // allow if project path matches, TODO: check with server
    if (user && projectKey) {
      return `/${user}/${projectKey}`
    }
    return '/'
  }

  const isAuthorised = this.isAuthorised()
  if (isAuthorised) {
    return redirectInside(route)
  }
  return redirectOutside(route)
}
